/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FormulaResponseDto
 */
export interface FormulaResponseDto {
    /**
     * ID Number for the Formula in the DB
     * @type {number}
     * @memberof FormulaResponseDto
     */
    forid: number;
    /**
     * Name of the Formula (must be unique per user)
     * @type {string}
     * @memberof FormulaResponseDto
     */
    name: string;
    /**
     * Doses field is not used
     * @type {object}
     * @memberof FormulaResponseDto
     */
    dose: object;
    /**
     * Estimated Cost of Formula
     * @type {number}
     * @memberof FormulaResponseDto
     */
    price: number;
    /**
     * Notes saved with this formula
     * @type {string}
     * @memberof FormulaResponseDto
     */
    notes: string;
    /**
     * Dynamic properties for the formula
     * @type {object}
     * @memberof FormulaResponseDto
     */
    meta: object;
    /**
     * Type of Dose for Formula
     * @type {number}
     * @memberof FormulaResponseDto
     */
    type: number;
    /**
     * Number of daily servings supplied
     * @type {number}
     * @memberof FormulaResponseDto
     */
    supply: number;
    /**
     * Desired Filler for the formula, associated by idnumber
     * @type {string}
     * @memberof FormulaResponseDto
     */
    filleridnumber: string;
    /**
     * Not used at this time
     * @type {object}
     * @memberof FormulaResponseDto
     */
    exactserving: object;
    /**
     * Number of doses per day
     * @type {number}
     * @memberof FormulaResponseDto
     */
    numberofdoses: number;
    /**
     * Volume of the formula for a daily serving
     * @type {number}
     * @memberof FormulaResponseDto
     */
    totalvolume: number;
    /**
     * Weight of the formula for a daily serving
     * @type {number}
     * @memberof FormulaResponseDto
     */
    totalweight: number;
    /**
     * Weight of the formula for the whole supply amount
     * @type {number}
     * @memberof FormulaResponseDto
     */
    supplyweight: number;
    /**
     * Number of servings for the whole supply
     * @type {number}
     * @memberof FormulaResponseDto
     */
    totalservings: number;
    /**
     * Contents of the formula
     * @type {Array<string>}
     * @memberof FormulaResponseDto
     */
    contents: Array<string>;
}

/**
 * Check if a given object implements the FormulaResponseDto interface.
 */
export function instanceOfFormulaResponseDto(value: object): value is FormulaResponseDto {
    if (!('forid' in value) || value['forid'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('dose' in value) || value['dose'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('supply' in value) || value['supply'] === undefined) return false;
    if (!('filleridnumber' in value) || value['filleridnumber'] === undefined) return false;
    if (!('exactserving' in value) || value['exactserving'] === undefined) return false;
    if (!('numberofdoses' in value) || value['numberofdoses'] === undefined) return false;
    if (!('totalvolume' in value) || value['totalvolume'] === undefined) return false;
    if (!('totalweight' in value) || value['totalweight'] === undefined) return false;
    if (!('supplyweight' in value) || value['supplyweight'] === undefined) return false;
    if (!('totalservings' in value) || value['totalservings'] === undefined) return false;
    if (!('contents' in value) || value['contents'] === undefined) return false;
    return true;
}

export function FormulaResponseDtoFromJSON(json: any): FormulaResponseDto {
    return FormulaResponseDtoFromJSONTyped(json, false);
}

export function FormulaResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormulaResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'forid': json['forid'],
        'name': json['name'],
        'dose': json['dose'],
        'price': json['price'],
        'notes': json['notes'],
        'meta': json['meta'],
        'type': json['type'],
        'supply': json['supply'],
        'filleridnumber': json['filleridnumber'],
        'exactserving': json['exactserving'],
        'numberofdoses': json['numberofdoses'],
        'totalvolume': json['totalvolume'],
        'totalweight': json['totalweight'],
        'supplyweight': json['supplyweight'],
        'totalservings': json['totalservings'],
        'contents': json['contents'],
    };
}

export function FormulaResponseDtoToJSON(json: any): FormulaResponseDto {
    return FormulaResponseDtoToJSONTyped(json, false);
}

export function FormulaResponseDtoToJSONTyped(value?: FormulaResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'forid': value['forid'],
        'name': value['name'],
        'dose': value['dose'],
        'price': value['price'],
        'notes': value['notes'],
        'meta': value['meta'],
        'type': value['type'],
        'supply': value['supply'],
        'filleridnumber': value['filleridnumber'],
        'exactserving': value['exactserving'],
        'numberofdoses': value['numberofdoses'],
        'totalvolume': value['totalvolume'],
        'totalweight': value['totalweight'],
        'supplyweight': value['supplyweight'],
        'totalservings': value['totalservings'],
        'contents': value['contents'],
    };
}

